const Selector = {
  CUSTOMFILE: '.form-file input[type="file"]',
  CUSTOMFILELABEL: '.form-file-label',
  FORM: 'form',
  INPUT: 'input',
}

export default Selector
